import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../service/auth.service';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { SocketService } from 'src/app/services/app/socket-service/socket-service.service';
import * as moment from 'moment';
import { sweetAlert } from 'src/app/utils/swal';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { passwordMatchValidator, passwordValidator, timeZone } from 'src/app/utils/utils.common';
import { phoneNumberLengthValidator } from 'src/app/utils/utils.common';
import { addressValidator } from 'src/app/utils/custom-validators';
import { jwtDecode } from 'jwt-decode';
// import { SocketService } from 'src/app/services/socket-service/socket-service.service';
@UntilDestroy()

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  registerForm!: FormGroup;
  submitted = false;
  timezones: any = moment.tz.names();
  showPassword = false;
  showConfirmPassword = false;
  user: any = null;
  token: any;
  provider:string='';
  state:string='';

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private route:ActivatedRoute,
    private sharedDataService: SharedDataService,
    private socket: SocketService,
  ) { }

  ngOnInit(): void {

    this.route.fragment.subscribe(fragment => {
      const params = new URLSearchParams(fragment || '');
      this.token = params.get('id_token');
      this.state = params.get('state') || '';
      if (this.token && this.token !== "") {
        if (this.state === 'apple') {
          this.getAppleResponse()
        } else {
          this.getGoogleResponse()
        }
      }
    })
    this.registerForm = this.fb.group({

      firstName: ['', Validators.required],
      lastName: ['', Validators.required],

      contactNumber: ['', [Validators.required, phoneNumberLengthValidator]],
      email: ['', [Validators.required, Validators.email]],

      address: this.fb.group({
        name: [''],
        coords: [[]],
        city: [''],
        state: [''],
        zipCode: [''],
        aptSuiteRoom: [''],
      }, { validators: addressValidator() }),

      timeZone: [timeZone, Validators.required],

      password: ["", [Validators.required, Validators.minLength(8), Validators.maxLength(16), passwordValidator]],
      confirmPassword: ["", [Validators.required, Validators.minLength(8), Validators.maxLength(16)]]

    }, { validators: passwordMatchValidator });
       
  }
  setOptional(controlName: string) {
    const control = this.registerForm.get(controlName);
    control?.clearValidators();
    control?.updateValueAndValidity();
  }

  getGoogleResponse() {
    this.provider = 'google';
    const googleResponse = (jwtDecode(this.token));
    this.user = googleResponse;

    const payload = {
      token: this.token,
      provider: this.provider,
      role: 'member'
    };
  console.log("Google response", payload)
    this.authService.socialSignIn(payload).subscribe({
      next: (res) => {
        if (res && res.user && res.tokens) {
          this.storeUserData(res);
        }
      },

      error: (err) => {
        if (err && err.error && err.error.code === 401) {
          this.registerForm.patchValue({
            firstName: this.user?.given_name || '',
            lastName: this.user?.family_name || '',
            email: this.user?.email || '',
          });

          ['password', 'confirmPassword']
            .forEach(field => this.setOptional(field));

          this.registerForm.clearValidators();

        } else {
          sweetAlert("Error", err.error.message || "Login failed. Please try again.", "error", "OK");
        }
      },


    });

  }

  getAppleResponse() {
    this.provider = 'apple';
    const payload = {
      token: this.token,
      provider: this.provider,
      role: "member",
    };

    this.authService.socialSignIn(payload).subscribe({
      next: (res) => {
        if (res && res.user && res.tokens) {
          this.storeUserData(res);
        }
      },

      error: (err) => {
        if (err && err.error && err.error.code === 401) {
          sweetAlert("Info", "No account found with this Apple ID. Please complete registration.", "info", "OK");
          ['password', 'confirmPassword']
            .forEach(field => this.setOptional(field));
          this.registerForm.clearValidators();
        } else {
          sweetAlert(
            "Error",
            err.error.message || "Login failed. Please try again.",
            "error",
            "OK",
          );
        }
      },


    });
  }

  onRegister() {
    this.submitted = true;
    this.registerForm.markAllAsTouched();
  

    if (this.registerForm.invalid) {
      return;
    }
    const {confirmPassword, ...payload} = this.registerForm.value;
    if(this.token && this.token !== "") {
      payload['token'] = this.token;
      payload['provider'] = this.provider;
      delete payload.password;
    }
    this.authService
      .register(payload)
      // .pipe(takeUntil(componentDestroyed(this)))
      .pipe(untilDestroyed(this)).subscribe(data => {
        if (data) {
          console.log('Registration successful', data);
          sweetAlert("Success", "Registration successful! Please log in.", "success", "OK");
          this.router.navigateByUrl('/login');
          this.user = null;
        } 
      }, (err) => {
        sweetAlert("Error", err, "error", "Ok");
      }

      );
  }

  storeUserData(res: any) {
    const userData = {
      ...res.user,
      tokens: res.tokens
    };
    this.sharedDataService.saveUser(userData);

    const tokens = res.tokens;

    if (tokens.access?.token) {
      this.authService.setToken('access_token', tokens.access.token);
    }

    if (tokens.refresh?.token) {
      this.authService.setToken('refresh_token', tokens.refresh.token);
    }

    this.socket.connectSocket();
    this.router.navigateByUrl('/');

  }
  onSelectAddress(place: any): void {
    const selectedAddress = place.address_components;
    const city = selectedAddress.find((data: any) =>
      data.types.includes('locality') || data.types.includes('administrative_area_level_2')
    );
    const cityName = city ? city.long_name : '';
    const state = selectedAddress.find((data: any) =>
      data.types.includes('administrative_area_level_1')
    );
    const stateName = state ? state.long_name : '';
    const zipCode = selectedAddress.find((data: any) =>
      data.types.includes('postal_code')
    );
    const zip = zipCode ? zipCode.long_name : '';

    this.registerForm.patchValue({
      address: {
        city: cityName,
        state: stateName,
        name: place.formatted_address,
        zipCode: zip,
        coords: [
          place.geometry.location.lng(),
          place.geometry.location.lat()
        ]
      }
    });
  }

  onChangeAddress() {
    this.registerForm.patchValue({
      address: {
        coords: '',
        city: '',
        state: '',
        zipCode: '',
      }
    });
  }


  toggleVisibility(field: 'password' | 'confirmPassword') {
    this[field === 'password' ? 'showPassword' : 'showConfirmPassword'] =
      !this[field === 'password' ? 'showPassword' : 'showConfirmPassword'];
  }

  get form() {
    return this.registerForm.controls;
  }
  get addressForm() {
    return this.registerForm.controls.address as FormGroup;
  }


  ngOnDestroy(): void { }

}
